/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Create_Space_ValidationInputs */



/**
* | output |
* | --- |
* | "Enter a name with at least 3 characters." |
*
* @param {Datasets_Create_Space_ValidationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_create_space_validation = /** @type {((inputs?: Datasets_Create_Space_ValidationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Create_Space_ValidationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie einen Namen mit mindestens 3 Zeichen ein.")
	return /** @type {LocalizedString} */ ("Enter a name with at least 3 characters.")
});